import { footerPartners } from '@/mocks/51cgHomeData';

export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const id = href.replace('#', '');
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const quickLinks = [
    { label: '热度榜单', href: '#ranking' },
    { label: '吃瓜导航', href: '#index' },
    { label: '投稿爆料', href: '#contact' },
    { label: '重磅专题', href: '#carousel' },
    { label: '精彩视频', href: '#media' },
    { label: '手机吃瓜', href: '#app' },
  ];

  return (
    <footer id="footer" className="w-full bg-primary-900 text-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto py-12 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">

          <div>
            <span className="text-lg md:text-xl font-heading text-accent-400 mb-3 block">
              51cg吃瓜网
            </span>
            <p className="text-xs md:text-sm text-background-300/80 leading-relaxed">
              51cg吃瓜网专注收录51cg莫里秀全集、51cg爆料内幕与51cg情感八卦内容。51cg.fun黑料吃瓜网旗下品牌，51cg在线观看持续更新，全网最快吃瓜第一站。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-3">快速导航</h4>
            <div className="grid grid-cols-2 gap-2">
              {quickLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  onClick={(e) => handleNavClick(e, link.href)}
                  className="text-xs md:text-sm text-background-300/80 hover:text-accent-400 transition-colors whitespace-nowrap"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-3">热门专题</h4>
            <div className="flex flex-col gap-2">
              <span className="text-xs md:text-sm text-background-300/80">51cg莫里秀找爹全集</span>
              <span className="text-xs md:text-sm text-background-300/80">51cg黑料合集精选</span>
              <span className="text-xs md:text-sm text-background-300/80">51cg情感八卦热榜</span>
              <span className="text-xs md:text-sm text-background-300/80">51cg在线观看专区</span>
              <span className="text-xs md:text-sm text-background-300/80">51cg.fun黑料吃瓜</span>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-3">{footerPartners[0]}</h4>
            <p className="text-xs text-background-300/60">合作伙伴信息持续更新中</p>
          </div>
        </div>

        <div className="border-t border-background-700/50 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-300/60">
            &copy; 2026 51cg吃瓜网. 本站内容仅供娱乐参考，不构成任何投资或法律建议。
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-background-300/60">51cg.fun黑料吃瓜网</span>
            <span className="text-xs text-background-300/60">51cg莫里秀</span>
            <span className="text-xs text-background-300/60">51cg爆料</span>
          </div>
        </div>
      </div>
    </footer>
  );
}